import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'app/appStore';
import {
	clearInfinityScroll,
	setInfinityScrollOffset,
	setInfinityScrollPage,
	setIsAllowWrite,
	setIsOpenFrozenPopup,
} from 'shared/model';

export const useCommonSlice = () => {
	const dispatch = useDispatch();

	return {
		...useSelector((s: RootState) => s.commonSlice),
		setInfinityScrollOffset: (offset: number) => dispatch(setInfinityScrollOffset(offset)),
		setIsOpenFrozenPopup: (offset: boolean) => dispatch(setIsOpenFrozenPopup(offset)),
		setInfinityScrollPage: (page: number) => dispatch(setInfinityScrollPage(page)),
		clearInfinityScroll: () => dispatch(clearInfinityScroll()),
		setIsAllowWrite: (isAllowWrite: boolean) => dispatch(setIsAllowWrite(isAllowWrite)),
	};
};
